import type { CSSObject } from '@emotion/react'
import { colors } from 'settings/colors'

export const createBadgeStyles = (
  diameter: number,
  isSelected: boolean,
  isWeatherStation: boolean,
  customCSS?: CSSObject,
): CSSObject => ({
  position: 'relative',
  backgroundColor: colors.midnight,
  color: colors.white,
  fontSize: 14,
  fontWeight: 'bold',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: isWeatherStation ? 3 : '50%',
  border: `2px solid ${isSelected ? 'yellow' : colors.white}`,
  padding: '0 3px',
  flexDirection: 'column',
  maxWidth: 220,
  width: diameter,
  height: diameter,
  ...customCSS,
})
